
<div class="UNFAPP-focusexam-mdlcnt-area">
    <span class="UNFAPP-dialog-clsbtn">
        <img class="UNFAPP-dialog-clsbtn-img" src="assets/img/filter-close-icon.png" (click)='close()'/>
    </span>
    <h5 class="UNFAPP-focusexam-mdl-title">Select an exam to focus</h5>

    <div class="UNFAPP-trgt-examlst-scrlarea">
        <div class="UNFAPP-trgt-examlstbx UNFAPP-scrollable">
            <ul class="UNFAPP-examlst">
                <li *ngFor="let exam of exams; index as i" >
                    <label class="UNFAPP-examlabel">
                        <input type="radio" (click)="selectExam(i)" [checked]="i === hignlightExam">
                        <div class="UNFAPP-labelinfo">
                            <h3 class="UNFAPP-examlabel-hdng">{{exam.name}}</h3>
                            <p>{{exam.description}}</p>
                        </div>
                    </label>
                </li>
            </ul>
        </div>
    </div>
    <!-- footer action section -->
    <div class="UNFAPP-modal-ftr-actn-area">
        <button class="UNFAPP-modal-txtlink" (click)="editPreference()">EDIT PREFERENCES </button>
        <button class="UNFAPP-modal-blubtn" (click)="onClickConfirm();">CONFIRM</button>
    </div>


</div>